import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { Subject } from 'rxjs';
import { NNotificationModal } from './notification.interfaces';

@Injectable({
    providedIn: 'root'
})
export class NotificationInitiatorService extends AbstractDfModalInitiatorService<NNotificationModal.IModalData> {
    /**
     * Notifiactions subject
     */
    private notifications = new Subject<NNotificationModal.IModalData>();

    constructor(dfModalService: DfModalService, app: App) {
        super(dfModalService, app);
    }

    listen(cb: (data: NNotificationModal.IModalData) => Promise<any> | void): Promise<void> {
        return new Promise(resolve => {
            this.notifications.subscribe(cb);
            resolve();
        });
    }

    /**
     * Push next notification
     */
    push(data: NNotificationModal.IModalData) {
        this.notifications.next(data);
    }
}
